export default class SidebarNav {
  init($) {
    const locations = window.locations || null;

    $('.sidebar-links-trigger').unbind('click').click(() => {
      const sidebarLinks = $('.sidebar-links');
      const triggerICon = $('.trigger-icon');
      if (sidebarLinks.hasClass('d-sm-block')) {
        sidebarLinks.removeClass('d-none d-sm-block');
        triggerICon.removeClass('vively-down');
        triggerICon.addClass('vively-up');
      } else {
        sidebarLinks.addClass('d-none d-sm-block');
        triggerICon.removeClass('vively-up');
        triggerICon.addClass('vively-down');
      }
    });

    $('.suburb-link').on('click', function () {
      SidebarNav.refresh($(this).attr('href'), $);
    });

    if (locations) {
      SidebarNav.refresh(window.location.hash, $);
    }
  }

  static refresh(hash, $) {
    const locations = window.locations || null;

    if (locations) {
      const mainSuburb = Object.entries(locations).filter(suburb => suburb[1].is_base_suburb === '1').map(x => x[1]).pop();
      const suburb = hash.substring(hash.indexOf('=') + 1, hash.length);

      if (suburb) {
        const breadcrumb = $('.breadcrumbs').find(`a[href*='${mainSuburb.suburb_seo_key}']`);

        if (breadcrumb.length) {
          breadcrumb.attr('href', `${breadcrumb.attr('href').split('#')[0]}#suburb=${locations[suburb].suburb_seo_key}`);
          breadcrumb.find('span').text(locations[suburb].suburb);
        }

        $('.suburb-name').text(locations[suburb].suburb);
      }
    }
  }
}




// WEBPACK FOOTER //
// ./minisite/scripts/sidebar-nav.js